<template>
  <v-container grid-list-md class="px-0 pb-0 pt-2 ma-0">
    <v-layout row wrap>
      <v-flex xs6>
        <router-link :to="{ path: '/Facdash/' }" style="text-decoration: none; color: black;">
          <v-btn small text class="px-0 pb-0 pt-2 ml-0"><v-icon>mdi-keyboard-backspace</v-icon></v-btn>
        </router-link>
      </v-flex>
      <v-flex xs6 class="text-right">
        <v-btn class="accent" @click="downloadAsPdf">Download As Pdf</v-btn>
      </v-flex>
      <v-flex xs12 id="pdf_report">
        <v-card flat>
          <v-card-title class="pa-0 title">
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs6>
                  <div style="text-align: left; padding-top: 8px;">{{lReport.comm_name}} - FM Daily Report ({{handy.formatDate(lReport.rep_date)}})</div>
                </v-flex>
                <v-flex xs6 style="padding: 6px 6px 0px;">
                  <div style="text-align: right;">
                    <img height="100" width="250" :src="handy.loadImg('img/logo/integra_logo.png', true)" aspect-ratio="1"></v-img>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-divider style="border-top:1px solid black"></v-divider>
            </v-flex>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-flex xs12 class="pa-0">
              <v-flex xs12 class="pa-0">
                <v-layout>
                  <v-flex xs12 class="text-center px-0 py-3">
                    <div style="color: #ff7f2a; font-size: 20px; font-weight: bold;" class="text-center">Attendance: {{lReport.attAve ? lReport.attAve : 0}}% ({{lReport.tot_present + (lReport.tot_ot ? ' + ' + lReport.tot_ot : '') + '/' + lReport.tot_staff}})</div>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-layout>
                  <v-flex v-for="(item, i) in lReport.roleCat" :key="i" style="padding: 0px; border: 1px solid black;">
                    <div style="text-align: center; padding: 8px 0px; font-size: 12px; background-color: #215868; color: #fff;">{{item}}</div>
                    <v-data-table
                    hide-default-header
                    :items="lReport.attHeader.filter(rec => rec.role_cat === item)"
                    hide-default-footer
                    disable-sort
                    >
                    <template slot="item" slot-scope="props">
                      <tr>
                        <td style="font-size: 12px;background-color: #0088aa; color: #fff; text-align: center;" v-for="(att, k) in props.item.attHead" :key="k">
                          {{ att.short_form }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                    <v-data-table
                    hide-default-header
                    :items="attList.filter(rec => rec.role_cat === item)"
                    hide-default-footer
                    disable-sort
                    >
                    <template slot="item" slot-scope="props">
                      <tr>
                        <td style="font-size: 12px; text-align: center; padding: 0px;" v-for="(att, k) in props.item.attendance" :key="k">
                          {{ att.tot_present }}
                          <span v-if="att.tot_wo || att.tot_holiday || att.tot_leave || att.tot_absent || att.tot_hd"><br/></span>
                          <span v-if="att.tot_wo" style="font-size: 9px;">{{ ' WO' + att.tot_wo }}</span>
                          <span v-if="att.tot_holiday" style="font-size: 9px;">{{ ' H' + att.tot_holiday }}</span>
                          <span v-if="att.tot_leave" style="font-size: 9px;">{{ ' L' + att.tot_leave }}</span>
                          <span v-if="att.tot_absent" style="font-size: 9px;">{{ ' A' + att.tot_absent }}</span>
                          <span v-if="att.tot_hd" style="font-size: 9px;">{{ ' HD' + att.tot_hd }}</span>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs6>
                <div style="text-align: left; padding-top: 0px; font-size: 12px;">
                  NOTE: Attendance % includes weekly offs(W), holidays(H) and leaves(L)
                </div>
              </v-flex>
              <v-flex xs6>
                <div style="text-align: right; padding-top: 0px; padding-right: 2px; font-size: 12px;">
                  X+Y/Z where X total present+HD, Y is OT+S, Z is total number of staff
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <div class="caption pl-1" v-if="lReport.remark_attendance">
            <span style="font-weight: bold; font-size: 11px;">Remark:</span> {{ lReport.remark_attendance ? lReport.remark_attendance : 'NA' }}
          </div>
          <v-flex xs12 class="pa-0">
            <div style="color: #ff7f2a; font-size: 20px; font-weight: bold; text-align: center; padding: 0px 0px 7px;">Power Management</div>
          </v-flex>
          <v-flex xs12 style="border: 1px solid black;">
            <v-layout row wrap>
              <v-flex xs12 sm2 class="pa-0">
                <div style="font-size: 11px; text-align: center; padding: 8px 0px; background-color: #215868; color: #fff;">CONSUMPTION</div>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs4 style="font-size: 11px; height: 78px; background-color: #0088aa; color: #fff; text-align: center; padding: 16px 0px;">
                      <span>EB</span>
                    </v-flex>
                    <v-flex xs8 style="font-size: 11px; text-align: center; padding: 16px 0px;">
                      <span>{{lReport.eb_unit}} units</span>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs4 style="font-size: 11px; height: 78px; background-color: #0088aa; color: #fff; text-align: center; padding: 16px 0px;">
                      <span>DG</span>
                    </v-flex>
                    <v-flex xs8 style="font-size: 11px; text-align: center; padding: 16px 0px;">
                      <span>{{lReport.dg_unit}} units</span>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-flex>
              <v-flex xs12 sm10 class="pa-0">
                <div style="font-size: 11px; text-align: center; padding: 8px 0px; background-color: #215868; color: #fff;">DISTRIBUTION (UNITS)</div>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs6 class="pa-0">
                      <div id="div_powercons" style="text-align: center;">
                        <canvas id="chart_powercons"></canvas>
                      </div>
                    </v-flex>
                    <v-flex xs6 style="text-align: center; padding: 0px 0px 0px 4px;">
                      <div id="div_powergenset">
                        <canvas id="chart_powergenset"></canvas>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs12 style="margin-top: 8px;">
                <v-layout row wrap>
                  <v-flex xs8 class="pa-0" style="border: 1px solid black;">
                    <v-flex xs12 style="font-size: 11px; text-align: center; padding: 8px 0px; background-color: #215868; color: #fff;">
                      <div>DG SUMMARY</div>
                    </v-flex>
                    <v-flex xs12 class="pa-0">
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th style="text-align: center; width: 57px; font-size: 11px; background-color: #0088aa; color: #fff; padding: 4px;" v-for="item in gensetHead" :key="item.text">{{item.text}}</th>
                            </tr>
                          </thead>
                          <tbody v-if="gensetList.length > 0">
                            <tr style="text-align: center;" v-for="item in gensetList" :key="item.name">
                              <td style="font-size: 11px; width: 139px;" class="pr-0">{{ item.genset_nm ? item.genset_nm : '-' }}</td>
                              <td style="font-size: 11px; width: 139px;" class="px-0">{{ item.units_cons ? item.units_cons : '-' }}</td>
                              <td style="font-size: 11px; width: 139px;" class="px-0">{{ item.level ? item.level + '%' : '-' }}</td>
                              <td style="font-size: 11px; width: 139px;" class="px-0">{{ item.fuel_eff ? item.fuel_eff : '-' }}</td>
                            </tr>
                          </tbody>
                          <tbody v-else>
                            <tr>
                              <td colspan="5" style="text-align: center;">No data available</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-flex>
                  </v-flex>
                  <v-flex xs4 class="pa-0" style="border: 1px solid black;">
                    <v-flex xs12 style="font-size: 11px; text-align: center; padding: 8px 0px; background-color: #215868; color: #fff;">
                      <div>DIESEL PURCHASE &amp; STOCK</div>
                    </v-flex>
                    <v-flex xs12 class="pa-0">
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th style="text-align: center; width: 57px; font-size: 11px; background-color: #0088aa; color: #fff; padding: 4px;" v-for="item in dieselHead" :key="item.text">{{item.text}}</th>
                            </tr>
                          </thead>
                          <tbody v-if="dieselList.length > 0">
                            <tr style="text-align: center;" v-for="item in dieselList" :key="item.name">
                              <td style="font-size: 11px; width: 173px;" class="pr-0">{{ item.diesel_nm ? item.diesel_nm : '-' }}</td>
                              <td style="font-size: 11px; width: 173px;" class="pl-4">{{ item.val ? item.val : '-' }}</td>
                            </tr>
                          </tbody>
                          <tbody v-else>
                            <tr>
                              <td colspan="2" style="text-align: center;">No data available</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <div class="caption pl-1" v-if="lReport.remark_power">
            <span style="font-size: 11px; font-weight: bold;">Remark:</span> {{ lReport.remark_power ? lReport.remark_power : 'NA' }}
          </div>
          <v-flex xs12 class="px-0 pt-2 pb-0" :id="(dieselList.length === 0 ? 'pageBreak' : (dieselList.length < 3 ? '' : 'pageBreak'))">
            <div style="color: #ff7f2a; font-size: 20px; font-weight: bold; text-align: center; padding: 0px 0px 7px;">Water Management</div>
          </v-flex>
          <v-flex xs12 style="border: 1px solid black;" class="pa-0">
            <v-layout row wrap>
              <v-flex xs12 sm5 style="width: 450px; padding-left: 0px; padding-right: 0px;">
                <v-flex xs12 style="font-size: 11px; text-align: center; padding: 8px 0px; background-color: #215868; color: #fff;">
                  <span>WATER LEVEL (%)</span>
                </v-flex>
                <v-flex xs12>
                  <div id="div_waterlevel" style="text-align: center">
                    <canvas id="chart_waterlevel"></canvas>
                  </div>
                </v-flex>
              </v-flex>
              <v-flex xs12 sm5 style="width: 450px; padding-left: 0px; padding-right: 0px;">
                <v-flex xs12 style="font-size: 11px; text-align: center; padding: 8px 0px; background-color: #215868; color: #fff;">
                  <span>CONSUMPTION (KL)</span>
                </v-flex>
                <v-flex xs12 style="text-align: center;">
                  <div id="div_watercons">
                    <canvas id="chart_watercons"></canvas>
                  </div>
                  <div style="font-size: 14px; padding-left: 2px;">
                    <span style="font-weight: bold;">Total water consumed: {{ lReport.tot_water_cons > 0 ? lReport.tot_water_cons.toFixed(2) + ' KL' : '0 KL' }}</span>
                  </div>
                </v-flex>
              </v-flex>
              <v-flex xs12 sm2 style="width: 170px; padding-left: 0px; padding-right: 0px;">
                <v-flex xs12 style="font-size: 11px; text-align: center; padding: 8px 0px; background-color: #215868; color: #fff;">
                  <span>SOURCES (KL)</span>
                </v-flex>
                <v-flex xs12 v-for="(wat, i) in domWatList" :key="i" class="py-2 pl-2">
                  <v-layout row wrap>
                    <v-flex xs9 class="text-left black--text">
                      <div style="font-size: 12px;">{{wat.water_type}}</div>
                    </v-flex>
                    <v-flex xs3 class="text-left black--text">
                      <div style="font-size: 12px;">{{wat.water_receipt ? wat.water_receipt : 0}}</div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 style="font-size: 11px; text-align: center; padding: 8px 0px; margin-top: 8px; background-color: #215868; color: #fff;">
            <div>WATER QUALITY &amp; CONTROL</div>
          </v-flex>
          <v-flex xs12 class="pa-0" style="border: 1px solid black;">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th style="text-align: center; width: 86px; font-size: 11px; background-color: #0088aa; color: #fff;" class="text-center pa-1" v-for="item in paramHead" :key="item.text">{{item.text}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in paramList" :key="item.name">
                    <td style="width: 174px; font-size: 11px; text-align: center;" class="pr-0">{{ item.water_qual }}</td>
                    <td style="text-align: center; font-size: 12px; padding: px; width: 174px;" :class="(watQualVal.val && (watQualVal.val < watQualVal.stdValMin || watQualVal.val > watQualVal.stdValMax) ? 'red white--text' : (watQualVal.val ? 'green lighten-3' : ''))" v-for="(watQualVal, i) in item.waterQualTypeValue" :key="i">
                      {{ watQualVal.val ? watQualVal.val : '-' }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-flex>
          <div class="caption pl-1" v-if="lReport.remark_water">
            <span style="font-size: 11px; font-weight: bold;">Remark:</span> {{ lReport.remark_water ? lReport.remark_water : 'NA' }}
          </div>
          <v-flex xs12 class="pa-0" id="pageBreak">
            <div style="color: #ff7f2a; font-size: 20px; font-weight: bold; text-align: center; padding: 7px 0px 7px;">Hygiene Management / Sanity Checks</div>
          </v-flex>
          <v-flex xs12 style="border: 1px solid black;">
            <v-layout row wrap>
              <v-flex xs12 style="font-size: 11px; text-align: center; padding: 8px 0px; background-color: #215868; color: #fff;">
                <span>SANITY CHECKS</span>
              </v-flex>
              <v-flex xs12 class="pa-0">
                <v-flex xs12 v-for="(cat, n) in hygCats" :key="n" class="pa-0">
                  <div style="font-size: 11px; background-color: #0088aa; text-align: left; color:#fff; padding: 8px;">{{cat.check_cat}}</div>
                  <v-data-table
                  hide-default-header
                  :items="hygList.filter(rec => rec.check_cat === cat.check_cat)"
                  hide-default-footer
                  :mobile-breakpoint="0"
                  >
                  <template slot="item" slot-scope="props">
                    <tr>
                      <td style="font-size: 11px; width:400px;" class="pr-0">{{ props.item.check_desc }}</td>
                      <td style="width: 50px;">
                        <v-checkbox v-model="props.item.check_value" hide-details readonly></v-checkbox>
                      </td>
                      <td style="font-size: 11px;">{{ props.item.remark }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-flex>
            <div class="caption pl-1" v-if="lReport.remark_sanity_checks">
              <span style="font-size: 12px; font-weight: bold;">Remark:</span> {{ lReport.remark_sanity_checks }}
            </div>
          </v-layout>
        </v-flex>
        <v-flex xs12 class="pa-0">
          <div style="color: #ff7f2a; font-size: 20px; font-weight: bold; text-align: center; padding: 7px 0px;">Safety &amp; Security</div>
        </v-flex>
        <v-flex xs12 style="border: 1px solid black;">
          <v-layout row wrap>
            <v-flex xs12 style="font-size: 11px; text-align: center; padding: 8px 0px; background-color: #215868; color: #fff;">
              <span>INCIDENTS</span>
            </v-flex>
            <v-flex xs12 class="pa-0" style="border: 1px solid black;">
              <v-flex xs12 v-for="(incident, n) in incidentTypes" :key="n" class="pa-0">
                <div style="background-color: #0088aa; text-align: left; color:#fff; padding: 8px;">{{incident}}</div>
                <v-flex xs12 class="pa-0">
                  <v-data-table
                  hide-default-header
                  :items="incidentList.filter(rec => rec.incident_type === incident)"
                  hide-default-footer
                  :mobile-breakpoint="0">
                  <template slot="item" slot-scope="props">
                    <tr>
                      <td style="width:315px;font-size: 11px; ">{{ props.item.incident_class }}</td>
                      <td style="font-size: 11px; ">{{ props.item.incident_on ? (handy.formatDate(props.item.incident_on) + ' ' + handy.getTime12Hrs(props.item.incident_on) + (props.item.incident_end ? ' to ' + handy.formatDate(props.item.incident_end) + ' ' + handy.getTime12Hrs(props.item.incident_end) : '') + ' - ' + props.item.incident_desc) : '' }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 class="pa-0">
        <div style="color: #ff7f2a; font-size: 20px; font-weight: bold; text-align: center; padding: 7px 0px;">Complaints &amp; Task Management</div>
      </v-flex>
      <v-flex xs12 style="border: 1px solid black;">
        <v-layout row wrap>
          <v-flex xs12 sm8 class="pa-0" style="border: 1px solid black;">
            <v-flex xs12 style="font-size: 11px; text-align: center; padding: 8px 0px; background-color: #215868; color: #fff;">
              <span>COMPLAINTS</span>
            </v-flex>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th style="text-align: center; width: 86px; font-size: 11px; background-color: #0088aa; color: #fff;" class="text-center pa-1" v-for="item in compHead" :key="item.text">{{item.text}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style="text-align: center;" v-for="item in compList" :key="item.name">
                    <td style="font-size: 11px; width: 139px;" class="pr-0">{{ item.comp_cat }}</td>
                    <td style="font-size: 11px; width: 139px;" class="px-0">{{ item.prev_pend }}</td>
                    <td style="font-size: 11px; width: 139px;" class="px-0">{{ item.new_today }}</td>
                    <td style="font-size: 11px; width: 139px;" class="px-0">{{ item.reop_today }}</td>
                    <td style="font-size: 11px; width: 139px;" class="px-0">{{ item.closed_today }}</td>
                    <td style="font-size: 11px; width: 139px;" class="px-0">{{ item.closing_bal }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-flex>
          <v-flex xs12 sm4 class="pa-0" style="border: 1px solid black;">
            <v-flex xs12 style="font-size: 11px; text-align: center; padding: 8px 0px; background-color: #215868; color: #fff;">
              <span>TASK</span>
            </v-flex>
            <div id="div_task" class="pt-3 pr-1" style="text-align: center;">
              <canvas id="chart_task"></canvas>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 class="pa-0" v-if="lMet.length > 0">
        <div style="color: #ff7f2a; font-size: 20px; font-weight: bold; text-align: center; padding: 7px 0px;">Custom Metrics</div>
      </v-flex>
      <v-flex xs12 v-if="lMet.length > 0">
        <v-layout row wrap>
          <v-flex xs3 v-for="(metric, n) in lMet" :key="n" style="border: 1px solid black; padding: 0px;">
            <div style="font-size: 11px; text-align: center; padding: 8px; background-color: #215868; color: #fff;" v-if="metric">
              {{ metric.metric_cat.toUpperCase() }}
            </div>
            <v-flex xs12 class="pa-0">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th style="text-align: center; width: 86px; font-size: 11px; background-color: #0088aa; color: #fff;" class="text-center pa-1" v-for="item in metHead" :key="item.text">{{item.text}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in metricList.filter(rec => rec.metric_cat === metric.metric_cat)" :key="item.name">
                      <td style="font-size: 11px; text-align: center; width: 150px; padding: 0px 2px 0px;">{{ item.metric_nm ? item.metric_nm : '-' }}</td>
                      <td style="font-size: 11px; text-align: center; width: 110px;">{{ item.metric_val ? item.metric_val : 0}}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-flex>
      <div class="caption pl-1" v-if="lReport.remark_custom_metrics">
        <span style="font-size: 12px; font-weight: bold;">Remark:</span> {{ lReport.remark_custom_metrics }}
      </div>
      <div class="caption pa-1" v-if="lReport.major_observ">
        <div class="text-xs-center title py-2 warning--text">Major Observation</div>
        <div class="pa-1" v-html="handy.getEditorStyle() + lReport.major_observ" style="font-size: 12px; border: 1px solid black;"></div>
      </div>
      <v-flex xs12 class="pa-0" id="pageBreak" v-if="lDailyUpdateAttach.files && lDailyUpdateAttach.files.length > 0">
        <div style="color: #ff7f2a; font-size: 20px; font-weight: bold; text-align: center; padding: 7px 0px;">Photos</div>
      </v-flex>
      <v-flex xs12>
        <v-container class="pa-0" fluid v-if="lDailyUpdateAttach.files && lDailyUpdateAttach.files.length > 0">
          <v-row>
            <v-col
            v-for="(file, index) in lDailyUpdateAttach.files" :key="index"
            class="d-flex child-flex pa-1"
            cols="4"
            >
            <v-card flat tile class="d-flex">
              <v-img
              :src="file.file_url"
              aspect-ratio="1"
              class="grey lighten-2"
              height="250px"
              >
              <div class="white--text text-center caption" style="background-color:rgba(125, 125, 125, 0.5);">{{handy.formatDateTime(file.attach_timestamp)}}<br />by {{file.user_name}}</div>
              <div style="position:absolute; bottom:0px; width:100%; background-color:rgba(0, 0, 255, 0.5);" class="text-center white--text caption" v-if="file.notes">
                {{ file.notes }}
              </div>
            </v-img>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-flex>
</v-card-text>
</v-card>
</v-flex>
</v-layout>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar" :timeout="2000" multi-line>
  <span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
var Chart = require('chart.js')
import 'chartjs-plugin-datalabels'
var html2pdf = require('html2pdf.js')

var COLORS = ['227,108,9', '49,133,155', '95,73,122', '118,146,60', '149,55,52', '54,96,146', '23,54,93', '73,68,41']

export default {
  props: ['action'],
  data () {
    return {
      // common
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      config: config,
      handy: handy,
      lReport: {},
      load: false,
      // Attendance
      attList: [],
      // complaint
      compHead: [
        { text: 'Category', value: 'comp_cat', class: 'pr-0 tertiary white--text', sortable: false },
        { text: 'Previous Pending', value: 'prev_pend', class: 'px-0 tertiary white--text', sortable: false },
        { text: 'Today’s New', value: 'new_today', class: 'px-0 tertiary white--text', sortable: false },
        { text: 'Reopened Today', value: 'reop_today', class: 'font px-2 primary white--text text-xs-center', sortable: false },
        { text: 'Closed Today', value: 'closed_today', class: 'px-0 tertiary white--text', sortable: false },
        { text: 'Closing Balance', value: 'closing_bal', class: 'px-0 tertiary white--text', sortable: false }
      ],
      compList: [],
      // water quality
      paramHead: [],
      paramList: [],
      // water sources
      domWatList: [],
      // custom Metrics
      lMet: {},
      metHead: [
        { text: 'Metric Name', value: 'metric_nm', class: 'tertiary white--text', width: '300px', sortable: false },
        { text: 'Value', value: 'metric_val', class: 'tertiary white--text', width: '100px', sortable: false }
      ],
      metricList: [],
      // DG
      lGenset: {},
      gensetHead: [
        { text: 'Genset', value: 'genset_nm', class: 'pl-2 pr-0 tertiary white--text', sortable: false },
        { text: 'Units(KWH)', value: 'units_cons', class: 'px-0 tertiary white--text', sortable: false },
        { text: 'Diesel Level (%)', value: 'level', class: 'px-0 tertiary white--text', sortable: false },
        { text: 'Fuel Eff.(Units/Liter)', value: 'fuel_eff', class: 'px-0 tertiary white--text', sortable: false }
      ],
      gensetList: [],
      dieselHead: [
        { text: 'Metric', value: 'diesel_nm', class: 'pr-0 tertiary white--text', sortable: false },
        { text: 'Quantity (ltr)', value: 'val', class: 'pl-4 tertiary white--text', sortable: false }
      ],
      dieselList: [],
      lgen: {},
      // Hygiene
      hygList: [],
      hygCats: {},
      // incident
      incidentList: [],
      incidentTypes: {},
      // comm values
      nodata: false,
      // for chart
      tmpChart: [],
      // photos
      lDailyUpdateAttach: {
        files: []
      }
    }
  },
  mounted () {
    var dateandcomm = this.action.split("_")
    this.lReport.comm_id = dateandcomm[0]
    this.lReport.rep_date = dateandcomm[1]
    this.loadAttReport()
    this.loadRemark()
    this.loadCompReport()
    this.loadPowerConsPieChart()
    this.loadPowerGensetPieChart()
    this.loadWaterLevelChart()
    this.loadWaterConsChart()
    this.loadWaterSources()
    this.loadWaterQualChart()
    this.loadMetricCat()
    this.loadTaskReport()
    this.loadGenset()
    this.loadHygieneCat()
    this.loadIncidentClass()
    this.loadFacDailyUpdateAttachment()
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadAttReport () {
      var qry = {
        params: {
          from_dt: handy.formatDBDate(this.lReport.rep_date),
          comm_id: this.lReport.comm_id
        }
      }
      this.lReport.attAve = 0
      var attVal = {
        tot_staff: 0,
        tot_present: 0,
        tot_hd: 0,
        tot_ot: 0,
        tot_wo: 0,
        tot_holiday: 0,
        tot_standBy: 0
      }
      this.lReport.roleCat = {}
      this.lReport.attHeader = []
      this.lReport.tot_staff = 0
      this.lReport.tot_present = 0
      this.lReport.tot_ot = 0
      this.axios.get(config.SMARTILITY_API_URL + '/getAttendanceDailyRep/', qry)
      .then(response => {
        this.lReport.comm_name = response.data[0].comm_name
        // total attendance in percentage
        this.lReport.roleCat = handy.unique(response.data.map(rec => rec.role_cat))
        response.data.forEach(rec => {
          attVal.tot_staff += rec.role_count
          attVal.tot_present += rec.tot_present + Number(rec.tot_hd / 2)
          attVal.tot_ot += rec.tot_ot
          attVal.tot_wo += rec.tot_wo
          attVal.tot_holiday += rec.tot_holiday
          attVal.tot_standBy += rec.tot_standBy
        })
        this.lReport.tot_staff = attVal.tot_staff
        this.lReport.tot_present = attVal.tot_present
        this.lReport.tot_ot = attVal.tot_ot
        this.lReport.roleCat.forEach(rec => {
          this.attList.push({
            role_cat: rec,
            attendance: []
          })
          this.lReport.attHeader.push({
            role_cat: rec,
            attHead: []
          })
        })
        for (var i = 0; i < response.data.length; i++) {
          for (var j = 0; j < this.attList.length; j++) {
            if (response.data[i].role_cat === this.attList[j].role_cat) {
              this.attList[j].attendance.push({
                tot_present: response.data[i].tot_present + Number(response.data[i].tot_hd / 2) + (response.data[i].tot_ot ? ' + ' + response.data[i].tot_ot : 0) + ' / ' + Number(response.data[i].role_count),
                tot_wo: response.data[i].tot_wo,
                tot_holiday: response.data[i].tot_holiday,
                tot_leave: response.data[i].tot_leave,
                tot_hd: response.data[i].tot_hd,
                tot_absent: response.data[i].tot_absent
              })
            }
          }
          for (var k = 0; k < this.lReport.attHeader.length; k++) {
            if (response.data[i].role_cat === this.lReport.attHeader[k].role_cat) {
              this.lReport.attHeader[k].attHead.push({
                short_form: response.data[i].short_form
              })
            }
          }
        }
        this.lReport.attAve = Math.round((attVal.tot_present + attVal.tot_ot + attVal.tot_standBy + attVal.tot_wo + attVal.tot_holiday) / attVal.tot_staff * 100)
        this.$forceUpdate()
        this.load = false
      })
      .catch(err => {
        this.msg(err, true)
        this.load = false
      })
    },
    loadRemark () {
      var qry = {
        params: {
          from_dt: handy.formatDBDate(this.lReport.rep_date),
          comm_id: this.lReport.comm_id
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getRemarksBasedOnCommId/', qry)
      .then(response => {
        if (response.data.length > 0) {
          this.lReport.remark_attendance = response.data[0].remark_attendance
          this.lReport.remark_water = response.data[0].remark_water
          this.lReport.remark_power = response.data[0].remark_power
          this.lReport.remark_sanity_checks = response.data[0].remark_sanity_checks
          this.lReport.remark_custom_metrics = response.data[0].remark_custom_metrics
          this.lReport.major_observ = response.data[0].major_observ
        }
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadCompReport () {
      var qry = {
        params: {
          to_dt: handy.formatDBDate(this.lReport.rep_date),
          from_dt: handy.formatDBDate(this.lReport.rep_date),
          comm_id: this.lReport.comm_id
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getComplaintDailyRep/', qry)
      .then(response => {
        this.compList = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadPowerConsPieChart () {
      var qry = {
        params: {
          comm_id: this.lReport.comm_id,
          from_dt: handy.formatDBDate(this.lReport.rep_date),
          to_dt: handy.formatDBDate(this.lReport.rep_date)
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getPowerMeterDailyRep/', qry)
      .then(response => {
        var resObj = response.data
        var areaLbl = []
        var unitConsVal = []
        this.lReport.eb_unit = 0
        // pie chart
        for (var i = 0; i < resObj.length; i++) {
          areaLbl[i] = resObj[i].area_covered
          unitConsVal[i] = 0
          if (!resObj[i].unit_cons) {
            resObj[i].unit_cons = 0
          }
          unitConsVal[i] += Number(resObj[i].unit_cons.toFixed(2))
          this.lReport.eb_unit += Number(resObj[i].unit_cons.toFixed(2))
        }
        var totZero = 0
        for (i = 0; i < unitConsVal.length; i++) {
          if (unitConsVal[i] === 0) {
            totZero++
          }
        }
        if (totZero === unitConsVal.length) {
          this.nodata = true
        } else {
          this.nodata = false
        }
        // chart 1
        // clear the content if any
        if (this.nodata) {
          setTimeout(() => {
            document.getElementById('div_powercons').innerHTML = 'No data available, check location and area covered configuration'
          }, 500)
          this.$forceUpdate()
        } else {
          setTimeout(() => {
            document.getElementById('div_powercons').innerHTML = '<canvas id="chart_powercons"></canvas>'
            var canvas = document.getElementById('chart_powercons')
            var ctx = canvas.getContext('2d')
            ctx.canvas.height = areaLbl.length * 2.5
            ctx.canvas.width = areaLbl.length * 7
            this.tmpChart = new Chart(ctx, {
              type: 'pie',
              data: {
                labels: areaLbl,
                datasets: [{
                  backgroundColor: ['#e36c09', '#31859b', '#5f497a', '#76923c', '#953734', '#366092', '#17365d', '#494429', '#5f4170', '#4c646e'],
                  data: unitConsVal
                }]
              },
              options: {
                plugins: {
                  datalabels: {
                    formatter: function (value) {
                      return value
                    },
                    color: '#ffffff'
                  }
                },
                title: {
                  display: true,
                  text: 'Electricity Board (Units)'
                },
                legend: {
                  position: 'left'
                }
              }
            })
          }, 500)
          this.$forceUpdate()
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadPowerGensetPieChart () {
      var qry = {
        params: {
          comm_id: this.lReport.comm_id,
          from_dt: handy.formatDBDate(this.lReport.rep_date),
          to_dt: handy.formatDBDate(this.lReport.rep_date)
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getPowerGensetPieChartByCommId/', qry)
      .then(response => {
        var resObj = response.data
        var gensetLbl = []
        var unitConsVal = []
        this.lReport.dg_unit = 0
        // pie chart
        for (var i = 0; i < resObj.length; i++) {
          gensetLbl[i] = resObj[i].genset_nm
          var unitVal = resObj[i].value
          unitConsVal[i] = 0
          for (var d = 0; d < unitVal.length; d++) {
            if (!unitVal[d].units_cons) {
              unitVal[d].units_cons = 0
            }
            unitConsVal[i] += Number(unitVal[d].units_cons)
            this.lReport.dg_unit += unitConsVal[i]
          }
        }
        // chart 1
        // clear the content if any
        if (response.data.length === 0) {
          setTimeout(() => {
            document.getElementById('div_powergenset').innerHTML = 'No data available for DG'
          }, 500)
          this.$forceUpdate()
        } else if (this.lReport.dg_unit === 0) {
          setTimeout(() => {
            document.getElementById('div_powergenset').innerHTML = 'DGs were not run today'
          }, 500)
          this.$forceUpdate()
        } else {
          setTimeout(() => {
            document.getElementById('div_powergenset').innerHTML = '<canvas id="chart_powergenset"></canvas>'
            var canvas = document.getElementById('chart_powergenset')
            var ctx = canvas.getContext('2d')
            ctx.canvas.height = gensetLbl.length * 1.7
            ctx.canvas.width = gensetLbl.length * 4.5
            this.tmpChart = new Chart(ctx, {
              type: 'pie',
              data: {
                labels: gensetLbl,
                datasets: [{
                  backgroundColor: ['#e36c09', '#31859b', '#5f497a', '#76923c', '#953734', '#366092', '#17365d', '#494429'],
                  data: unitConsVal
                }]
              },
              options: {
                plugins: {
                  datalabels: {
                    formatter: function (value) {
                      return value
                    },
                    color: '#ffffff'
                  }
                },
                title: {
                  display: true,
                  text: 'Genset (Units)'
                },
                legend: {
                  position: 'left'
                }
              }
            })
          }, 500)
          this.$forceUpdate()
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadWaterLevelChart () {
      var qry = {
        params: {
          comm_id: this.lReport.comm_id,
          from_dt: handy.formatDBDate(this.lReport.rep_date) + ' 00:00:00',
          to_dt: handy.formatDBDate(this.lReport.rep_date) + ' 23:59:59'
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getWaterLevelChartDetailsByCommId/', qry)
      .then(response => {
        // retrive data from db and construct chart
        var resObj = response.data
        var watTypeLbl = []
        var levelVal = {}
        var gw = 0
        var dtLbl = [] // for trend chart
        var waterLvlKl = {}
        var gd = 0
        var idx = 0
        for (var i = 0; i < resObj.length; i++) {
          watTypeLbl[gw] = resObj[i].storage_nm
          levelVal[gw] = []
          idx = gw++
          var lvl = resObj[i].levels
          for (var d = 0; d < lvl.length; d++) {
            if (lvl[d].water_level === '') {
              lvl[d].water_level = 0
            }
            var didx = dtLbl.indexOf(handy.formatDate(lvl[d].c_date))
            if (didx < 0 && lvl[d].c_date) {
              dtLbl[gd] = handy.formatDate(lvl[d].c_date)
              didx = gd++
            }
            if (dtLbl[didx] === handy.formatDate(this.lReport.rep_date)) {
              if (lvl[d].water_level) {
                levelVal[idx][i] = lvl[d].water_level // show specific data for the day in first graph in case of single date
              }
              if (lvl[d].water_level_kl) {
                waterLvlKl[i] = lvl[d].water_level_kl + ' KL'
              }
            }
          }
        }
        // chart 1
        // data set
        var value = []
        for (i = 0; i < watTypeLbl.length; i++) {
          value.push(levelVal[i][i])
        }
        var totZero = 0
        for (i = 0; i < value.length; i++) {
          if (value[i] === 0) {
            totZero++
          }
        }
        if (totZero === value.length) {
          this.nodata = true
        } else {
          this.nodata = false
        }
        if (this.nodata) {
          setTimeout(() => {
            document.getElementById('div_waterlevel').innerHTML = 'No data available'
          }, 500)
          this.$forceUpdate()
        } else {
          // clear the content if any
          document.getElementById('div_waterlevel').innerHTML = '<canvas id="chart_waterlevel"></canvas>'
          var canvas = document.getElementById('chart_waterlevel')
          canvas.height = watTypeLbl.length > 4 ? watTypeLbl.length * 18 : watTypeLbl.length * 42
          var ctx = canvas.getContext('2d')
          this.tmpChart = new Chart(ctx, {
            type: 'horizontalBar',
            data: {
              labels: watTypeLbl,
              datasets: [{
                backgroundColor: 'rgba(' + COLORS[1] + ',0.7)',
                data: value,
                fill: true
              }]
            },
            options: {
              tooltips: {enabled: false},
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false,
                position: 'bottom',
                labels: {
                  usePointStyle: true,
                  fontSize: 11
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    beginAtZero: true,
                    min: 0
                  }
                }]
              },
              hover: {
                animationDuration: 0
              },
              plugins: {
                datalabels: {
                  formatter: function (value) {
                    return value > 0 ? value + ' %' : ''
                  },
                  color: '#ffffff'
                }
              }
            }
          })
          this.$forceUpdate()
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadWaterConsChart () {
      var qry = {
        params: {
          comm_id: this.lReport.comm_id,
          from_dt: handy.formatDBDate(this.lReport.rep_date) + ' 00:00:00',
          to_dt: handy.formatDBDate(this.lReport.rep_date) + ' 23:59:59',
          comingFrom: 'Report',
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getWaterConsChartDetailsByCommId/', qry)
      .then(response => {
        // retrive data from db and construct chart
        var resObj = response.data
        var watTypeLbl = []
        var recVal = {}
        var dtLbl = [] // for trend chart
        var didx = 0
        var widx = 0
        var modeLbl = ['Consumed (KL)']
        recVal[0] = []
        this.lReport.tot_water_cons = 0
        for (var r = 0; r < resObj.length; r++) {
          var cons = resObj[r].cons
          for (var d = 0; d < cons.length; d++) {
            didx = dtLbl.indexOf(handy.formatDBDate(cons[d].c_date))
            if (didx < 0 && cons[d].c_date) {
              didx = dtLbl.length
              dtLbl[didx] = handy.formatDBDate(cons[d].c_date)
            }
            widx = watTypeLbl.indexOf(resObj[r].storage_nm.substring(0, 10))
            if (widx < 0) {
              widx = watTypeLbl.length
              watTypeLbl[widx] = resObj[r].storage_nm.substring(0, 10)
            }
            if (!recVal[0][widx]) {
              recVal[0][widx] = 0
            }
            recVal[0][widx] += Number(cons[d].water_cons)
          }
        }
        // to do: when automated for mulitple timestamps on the same day
        // chart 1 (water receipt and cons)
        // data set
        var dsets = []
        for (var i = 0; i < modeLbl.length; i++) {
          for (var j = 0; j < recVal[i].length; j++) {
            recVal[i][j] = recVal[i][j] > 0 ? recVal[i][j].toFixed(2) : ''
            this.lReport.tot_water_cons += Number(recVal[i][j])
          }
          dsets[i] = {
            label: modeLbl[i],
            backgroundColor: 'rgba(' + COLORS[i] + ',0.7)',
            borderColor: 'rgba(' + COLORS[i] + ',1)',
            data: recVal[i],
            fill: true
          }
        }
        if (this.lReport.tot_water_cons) {
          this.nodata = false
        } else {
          this.nodata = true
        }
        if (this.nodata) {
          document.getElementById('div_watercons').innerHTML = 'No data available, check water consumption configuration'
        } else {
          // clear the content if any
          document.getElementById('div_watercons').innerHTML = '<canvas id="chart_watercons"></canvas>'
          var canvas = document.getElementById('chart_watercons')
          var ctx = canvas.getContext('2d')
          this.tmpChart = new Chart(ctx, {
            type: 'horizontalBar',
            data: {
              labels: watTypeLbl,
              datasets: dsets
            },
            options: {
              plugins: {
                datalabels: {
                  formatter: function (value) {
                    return value || ''
                  },
                  color: '#fff'
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false,
                position: 'bottom',
                labels: {
                  usePointStyle: true,
                  fontSize: 11
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadWaterSources () {
      var qry = {
        params: {
          comm_id: this.lReport.comm_id,
          c_date: handy.formatDBDate(this.lReport.rep_date),
          from_dt: handy.formatDBDate(this.lReport.rep_date),
          to_dt: handy.formatDBDate(this.lReport.rep_date)
        }
      }
      this.lReport.tanker_nos = 0
      this.axios.get(config.SMARTILITY_API_URL + '/getWaterSourcesByCommIdAndcDate/', qry)
      .then(response => {
        if (response.data.length > 0) {
          this.domWatList = response.data
        }
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadWaterQualChart () {
      var qry = {
        params: {
          comm_id: this.lReport.comm_id,
          from_dt: handy.formatDBDate(this.lReport.rep_date),
          to_dt: handy.formatDBDate(this.lReport.rep_date)
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getDailyWaterQualityByCommId/', qry)
      .then(response => {
        // retrive data from db and construct chart
        var resObj = response.data
        var paramLbl = []
        var paramId = []
        var paramUoM = []
        var watTypeLbl = []
        var qualVal = {}
        var stdValMin = []
        var stdValMax = []
        var widx = 0
        var pidx = 0
        var dtIdx = 1
        for (var r = 0; r < resObj.length; r++) {
          pidx = paramId.indexOf(resObj[r].param_id)
          if (pidx < 0) {
            pidx = paramId.length
            paramId[pidx] = resObj[r].param_id
            paramLbl[pidx] = resObj[r].param_name
            qualVal[pidx] = []
          }
          widx = watTypeLbl.indexOf(resObj[r].water_type)
          if (widx < 0) {
            widx = watTypeLbl.length
            watTypeLbl[widx] = resObj[r].water_type
          }
          if (!qualVal[pidx][widx]) {
            qualVal[pidx][widx] = 0
          }
          qualVal[pidx][widx] = Number(resObj[r].val)
          paramUoM[pidx] = resObj[r].uom
          stdValMin[pidx] = Number(resObj[r].std_val_min)
          stdValMax[pidx] = Number(resObj[r].std_val_max)
        }
        // chart 1
        this.paramHead = [
          { text: 'Water Type', value: 'water_qual', class: 'primary white--text text-xs-center py-0', sortable: false }
        ]
        var minMax = ''
        for (var i = 0; i < paramLbl.length; i++) {
          if (stdValMin[i] && stdValMax[i]) {
            minMax = stdValMin[i] + ' to ' + stdValMax[i]
          } else if (stdValMin[i]) {
            minMax = 'min ' + stdValMin[i]
          } else {
            minMax = 'max ' + stdValMax[i]
          }
          // construct table headers dynamically
          this.paramHead.splice(dtIdx++, 0,
            {
              text: paramLbl[i] + '(' + paramUoM[i] + ') [' + minMax + ']', value: paramLbl[i], width: '160px', class: 'pl-2 pr-0 py-0 text-xs-center white--text primary', sortable: false
            }
          )
        }
        this.paramList = []
        for (i = 0; i < watTypeLbl.length; i++) {
          if (stdValMin[i] && stdValMax[i]) {
            minMax = stdValMin[i] + ' to ' + stdValMax[i]
          } else if (stdValMin[i]) {
            minMax = 'min ' + stdValMin[i]
          } else {
            minMax = 'max ' + stdValMax[i]
          }
          this.paramList.push({
            water_qual: watTypeLbl[i] === 'SWIMMING POOL' ? 'S. POOL' : watTypeLbl[i],
            waterQualTypeValue: []
          })
        }
        // find ave
        for (i = 0; i < paramLbl.length; i++) {
          for (var j = 0; j < watTypeLbl.length; j++) {
            if (qualVal[i][j] && qualVal[i][j] !== '  ') {
              qualVal[i][j] = (Number.isInteger(qualVal[i][j]) || qualVal[i][j] > 50) ? qualVal[i][j].toFixed(0) : qualVal[i][j].toFixed(1)
            }
          }
        }

        // construct value table for each parameter
        for (j = 0; j < watTypeLbl.length; j++) {
          for (i = 0; i < paramLbl.length; i++) {
            this.paramList[j].waterQualTypeValue.push({
              val: qualVal[i][j] || '',
              stdValMin: stdValMin[i],
              stdValMax: stdValMax[i]
            })
          }
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadMetricCat () {
      var qry = {
        params: {
          comm_id: this.lReport.comm_id
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getMetricCatByCommId/', qry)
      .then(response => {
        this.lMet = response.data.filter(rec => rec.metric_cat !== '')
        this.loadMetric(handy.formatDBDate(this.lReport.rep_date))
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    loadMetric (curDate) {
      var metCat = this.lMet.filter(rec => rec.metric_cat !== '')
      var qry = {
        params: {
          comm_id: this.lReport.comm_id,
          from_dt: curDate,
          to_dt: curDate,
          metric_cat: metCat.map(rec => rec.metric_cat)
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getMetricByCommId/', qry)
      .then(response => {
        this.metricList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    loadTaskReport () {
      var qry = {
        params: {
          comm_id: this.lReport.comm_id,
          from_dt: handy.formatDBDate(this.lReport.rep_date)
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getTaskReport/', qry)
      .then(response => {
        var resObj = response.data
        var statusLbl = []
        var totTaskVal = []
        // pie chart
        for (var i = 0; i < resObj.length; i++) {
          statusLbl[i] = resObj[i].task_status
          if (!resObj[i].tot_task_status) {
            totTaskVal[i] = 0
          } else {
            totTaskVal[i] = resObj[i].tot_task_status
          }
        }
        var totZero = 0
        for (i = 0; i < totTaskVal.length; i++) {
          if (totTaskVal[i] === 0) {
            totZero++
          }
        }
        if (totZero === totTaskVal.length) {
          this.nodata = true
        } else {
          this.nodata = false
        }
        // chart 1
        // clear the content if any
        if (this.nodata) {
          setTimeout(() => {
            document.getElementById('div_task').innerHTML = 'No data available'
          }, 500)
          this.$forceUpdate()
        } else {
          setTimeout(() => {
            document.getElementById('div_task').innerHTML = '<canvas id="chart_task"></canvas>'
            var canvas = document.getElementById('chart_task')
            canvas.height = statusLbl.length * 23
            canvas.width = statusLbl.length * 35
            var ctx = canvas.getContext('2d')
            this.tmpChart = new Chart(ctx, {
              type: 'pie',
              data: {
                labels: statusLbl,
                datasets: [{
                  backgroundColor: ['#e36c09', '#31859b', '#5f497a', '#76923c', '#953734', '#366092', '#17365d', '#494429'],
                  data: totTaskVal
                }]
              },
              options: {
                plugins: {
                  datalabels: {
                    formatter: function (value) {
                      return value || ''
                    },
                    color: '#ffffff'
                  }
                },
                title: {
                  display: false
                },
                legend: {
                  position: 'bottom'
                }
              }
            })
          }, 500)
          this.$forceUpdate()
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadGenset () {
      var qry = {
        params: {
          comm_id: this.lReport.comm_id,
          c_date: handy.formatDBDate(this.lReport.rep_date)
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getGensetByGensetId/', qry)
      .then(response => {
        this.gensetList = response.data
        this.lgen.totPurchasedStock = 0
        this.lgen.totStock = 0
        this.gensetList.forEach(rec => {
          this.lgen.totPurchasedStock += Number(rec.purchased)
          this.lgen.totStock += Number(rec.stock)
        })
        this.dieselList.push({
          diesel_nm: 'Diesel Purchased (ltr)',
          val: this.lgen.totPurchasedStock
        })
        this.dieselList.push({
          diesel_nm: 'Diesel Barrel Stock (ltr)',
          val: this.lgen.totStock
        })
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    loadHygieneCat () {
      var qry = {
        params: {
          comm_id: this.lReport.comm_id
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getSanCheckCatByCommId/', qry)
      .then(response => {
        this.hygCats = response.data
        this.loadHygiene()
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadHygiene () {
      var qry = {
        params: {
          comm_id: this.lReport.comm_id,
          from_dt: handy.formatDBDate(this.lReport.rep_date),
          to_dt: handy.formatDBDate(this.lReport.rep_date)
        }
      }
      this.hygList = []
      this.axios.get(config.SMARTILITY_API_URL + '/getSanCheckByCommIdAndcDate/', qry)
      .then(response => {
        this.hygList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadIncidentClass () {
      this.axios.get(config.SMARTILITY_API_URL + '/getIncidentClass/')
      .then(response => {
        this.incidentTypes = handy.unique(response.data.map(rec => rec.incident_type)).sort()
        this.loadIncidents()
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadIncidents () {
      var qry = {
        params: {
          comm_id: this.lReport.comm_id,
          from_dt: handy.formatDBDate(this.lReport.rep_date) + ' 00:00:00',
          to_dt: handy.formatDBDate(this.lReport.rep_date) + ' 23:59:59'
        }
      }
      this.incidentList = []
      this.axios.get(config.SMARTILITY_API_URL + '/getIncidentListDailyRep/', qry)
      .then(response => {
        if (response.data.length > 0) {
          this.incidentList = response.data
        } else {
          this.incidentTypes.forEach(rec => {
            this.incidentList.push({
              incident_type: rec,
              incident_class: 'NIL'
            })
          })
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadFacDailyUpdateAttachment () {
      var qry = {
        params: {
          comm_id: this.lReport.comm_id,
          from_dt: handy.formatDBDate(this.lReport.rep_date),
          to_dt: handy.formatDBDate(this.lReport.rep_date)
        }
      }
      this.lDailyUpdateAttach.files = []
      this.axios.get(config.SMARTILITY_API_URL + '/getAttachmentByCDate/', qry)
      .then(response => {
        this.lDailyUpdateAttach.files = response.data
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.lDailyUpdateAttach.files = []
      })
    },
    downloadAsPdf () {
      // pdf options
      let opt = {
        margin: 15,
        filename: this.lReport.comm_name + '_Report_' + handy.formatDate(this.lReport.rep_date) + '.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { orientation: 'landscape', scrollX: 0, scrollY: 0, width: 596 },
        pagebreak: { before: '#pageBreak' }
      }

      var canvas = document.getElementById('pdf_report')
      html2pdf(canvas, opt)
    }
  }
}
</script>
